var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.64 13.417v6.548a3.53 3.53 0 0 1-3.993 3.992H15.09a.4.4 0 0 1-.4-.4v-4.096a2.777 2.777 0 0 0-2.207-2.782 2.67 2.67 0 0 0-3.117 2.623v4.263a.4.4 0 0 1-.4.4H5.333a3.53 3.53 0 0 1-3.993-3.993v-6.555a5.897 5.897 0 0 0 2.53.559 6.665 6.665 0 0 0 4.087-1.411 6.49 6.49 0 0 0 8.081 0 6.666 6.666 0 0 0 4.087 1.41 5.875 5.875 0 0 0 2.515-.558zM6 0C2.67 0 2.152 1.091 1.611 2.713L.235 6.803a3.89 3.89 0 0 0 1.598 4.634 4.072 4.072 0 0 0 2.043.543 4.369 4.369 0 0 0 4.067-2.662 4.417 4.417 0 0 0 8.112 0 4.366 4.366 0 0 0 4.067 2.662 4.071 4.071 0 0 0 2.045-.543 3.891 3.891 0 0 0 1.598-4.634l-1.378-4.09C21.82 1.091 21.308 0 17.982 0H5.999z",
    fill: "#5E6175"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.b0ff23212d9ece2115ab68f2b64a7db4.svg";
export { ForwardRef as ReactComponent };